import { GridViewImageGallery, type GridviewImagePropTypes } from '@nextgen-web-framework/all';
import { FC } from 'react';
import { GridviewImagePropType } from './types/propTypes';
const GridViewGalleryContainer: FC<GridviewImagePropType> = ({ images, imagesPerRow }: GridviewImagePropType) => {
  const customProps: GridviewImagePropTypes = {
    images,
    imagesPerRow,
  };
  return <GridViewImageGallery {...customProps} />;
};

export default GridViewGalleryContainer;
